import { JsonObject, JsonProperty } from 'typescript-json-serializer';

@JsonObject()
export class StatisticsPeriod {
  @JsonProperty('From') from: Date;
  @JsonProperty('To') to: Date;
  @JsonProperty('Days') days: number;
}
